import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CarBrand, defaultCarBrand } from "../../models/responses/carBrand";

export interface CarBrandState {
    carBrandList: CarBrand[];
    carBrand: CarBrand;
    isWaitingCarBrandPostResponse: boolean;
    isWaitingCarBrandPutResponse: boolean;    
    totalQueryCarBrand: number;
    isWaitingCarBrandGetResponse: boolean;
}

const initialState: CarBrandState = {
    carBrandList: [],
    carBrand: { ...defaultCarBrand },
    isWaitingCarBrandPostResponse: false,
    isWaitingCarBrandPutResponse: false,
    isWaitingCarBrandGetResponse: false,    
    totalQueryCarBrand: 0,
};

const carBrandSlice = createSlice({
    name: 'carBrand',
    initialState,
    reducers: {
        setCarBrandList: (state, action: PayloadAction<{
            carBrands: CarBrand[];
        }>) => {
            state.carBrandList = action.payload.carBrands || initialState.carBrandList;
            return state;
        },
        setCarBrand: (state, action: PayloadAction<{
            carBrand: CarBrand;
        }>) => {
            state.carBrand = action.payload.carBrand || initialState.carBrand;
            return state;
        },
        setIsWaitingCarBrandPostResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingCarBrandPostResponse = action.payload;
        },
        setIsWaitingCarBrandPutResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingCarBrandPutResponse = action.payload;
        },
        setIsWaitingCarBrandGetResponse: (state, action: PayloadAction<boolean>) => {
            state.isWaitingCarBrandGetResponse = action.payload;
        }
    },
});

export const {
    setCarBrandList,
    setCarBrand,
    setIsWaitingCarBrandPostResponse,
    setIsWaitingCarBrandPutResponse,
    setIsWaitingCarBrandGetResponse,    
} = carBrandSlice.actions;

export default carBrandSlice.reducer;